<div  style="display:flex; height: 100%; padding-bottom:66px; justify-content: center;" *ngIf="itemsMenu">
    <div style="align-content: center;">
      <!-- Mostro htmlText -->
      <div class="mb-4 text-dark" [innerHTML]="itemsMenu?.htmlText"></div>
  
      <!-- Bottoni sottomenu -->
      <div class="row justify-content-center gx-2 gy-2" *ngIf="itemsMenu.submenu?.length > 0">
        <div 
          class="col-auto" 
          *ngFor="let sub of itemsMenu.submenu">
          <button 
            class="btn btn-kindera btn-sm px-4"
            (click)="navigate(sub.path)">
            <i [class]="sub.icon" class="me-2"></i> {{ sub.title }}
          </button>
        </div>
      </div>
    </div>
  </div>
  